import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import PropTypes from 'prop-types';
import { GatsbyImage } from 'gatsby-plugin-image';
import { fluidImage } from '../../utils';

const NumberDivider = ({ number }) => {
  const data = useStaticQuery(graphql`
    {
      allFile(filter: { relativePath: { regex: "/dividers/divider-[0-9]+.png/" } }) {
        nodes {
          absolutePath
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH)
          }
        }
      }
    }
  `);

  return <GatsbyImage image={fluidImage(data, `${number}.png`)} alt={`Divider ${number}`} className="image-block" />;
};

NumberDivider.propTypes = {
  number: PropTypes.string
};

export default NumberDivider;
